// Catalog of predefined items for moving requests

// Heavy Furniture Items
export const HEAVY_FURNITURE_ITEMS = [
  { id: 'sofa-2-3', name: 'ספה (2-3 מושבים)' },
  { id: 'sofa-4plus', name: 'ספה (4+ מושבים)' },
  { id: 'dining-table', name: 'שולחן אוכל' },
  { id: 'dining-chairs', name: 'כיסאות אוכל' },
  { id: 'double-bed', name: 'מיטה זוגית' },
  { id: 'single-bed', name: 'מיטה יחיד' },
  { id: 'mattress', name: 'מזרן' },
  { id: 'wardrobe', name: 'ארון בגדים' },
  { id: 'kitchen-cabinet', name: 'ארון מטבח' },
  { id: 'desk', name: 'שולחן עבודה/משרד' },
  { id: 'office-chair', name: 'כסא משרדי' },
  { id: 'bookshelf', name: 'כוננית ספרים' },
  { id: 'coffee-table', name: 'שולחן קפה' },
  { id: 'armchair', name: 'כורסה' },
  { id: 'nightstand', name: 'שידה' },
  { id: 'kitchen-island', name: 'אי מטבח' },
  { id: 'outdoor-table', name: 'שולחן חוץ' },
  { id: 'outdoor-chairs', name: 'כיסאות חוץ' },
  { id: 'piano', name: 'פסנתר' },
  { id: 'guitar-stand', name: 'עמוד גיטרה' },
  { id: 'treadmill', name: 'הליכון' },
  { id: 'exercise-bike', name: 'אופני כושר' },
  { id: 'ping-pong-table', name: 'שולחן פינג פונג' },
  { id: 'pool-table', name: 'שולחן ביליארד' },
  { id: 'weight-bench', name: 'ספסל משקולות' },
  { id: 'footrest', name: 'הדום רגליים' },
  { id: 'baby-bed', name: 'מיטת תינוק' },
  { id: 'baby-crib', name: 'עריסת תינוק' },
];

// Electrical Items
export const ELECTRICAL_ITEMS = [
  { id: 'refrigerator', name: 'מקרר' },
  { id: 'refrigerator-freezer', name: 'מקרר-מקפיא' },
  { id: 'washing-machine', name: 'מכונת כביסה' },
  { id: 'dryer', name: 'מייבש כביסה' },
  { id: 'tv-small', name: 'טלוויזיה (עד 50")' },
  { id: 'tv-large', name: 'טלוויזיה (55"+)' },
  { id: 'monitor', name: 'מסך מחשב' },
  { id: 'desktop-computer', name: 'מחשב נייח' },
  { id: 'laptop', name: 'מחשב נייד' },
  { id: 'microwave', name: 'מיקרוגל' },
  { id: 'oven', name: 'תנור אפייה' },
  { id: 'dishwasher', name: 'מדיח כלים' },
  { id: 'ac-unit', name: 'מזגן (יחידה אחת)' },
  { id: 'stereo', name: 'מכשיר סטריאו/רמקולים' },
  { id: 'ceiling-fan', name: 'מאוורר תקרה' },
  { id: 'fan', name: 'מאוורר' },
];

// Valid tags for items
export const ITEM_TAGS = [
  'שביר',
  'כבד מאוד',
  'גדול מימדים',
  'יקר ערך',
  'דורש פירוק/הרכבה',
  'דורש אריזה מיוחדת'
];

